<ng-template #panelAlerts>
  <div id="panel-alerts" class="panel-alerts">
    <!-- En compacto el header es el asa de la hoja: arrastrar hacia abajo cierra el panel -->
    <div
      class="modal-header p-2 header-panel"
      appSheetSwipe
      sheetSelector=".modal-content"
      [dismissOnSwipeDown]="isAdmin"
      (swipeDown)="closeModal()"
    >
      <div class="d-flex align-items-center flex-wrap p-2 border-header">
        <div class="d-none d-lg-flex align-items-center mr-3">
          <app-image-color
            [height]="'30px'"
            [width]="'40px'"
            [url]="'img/icons/test.svg'"
            [color]="'#ffffff'"
          ></app-image-color>
        </div>
        <div class="line d-none d-lg-flex"></div>
        <div class="text-left ml-2">
          <div class="flex-column">
            <h2 class="mb-0 d-flex align-items-start">
              {{ "panel-alerts.automatic-tests" | translate }}
              <span
                class="badge badge-light c-pointer help-badge"
                placement="bottom"
                [ngbTooltip]="'tooltip.test' | translate"
                >?</span
              >
            </h2>
            <p class="m-0">{{ "panel-alerts.send-actions-to-feeder" | translate }}</p>
          </div>
        </div>
      </div>
      <h3 class="m-0 c-pointer" (click)="closeModal()">&times;</h3>
    </div>

    <div class="modal-body panel-alerts__body">
      <div class="panel-alerts__grid">
        <!-- Fondo de la hoja de comandos: solo se ve en compacto con la hoja abierta -->
        <div
          class="panel-alerts__sheet-backdrop"
          [class.is-open]="commandsSheetOpen"
          (click)="closeCommandsSheet()"
        ></div>

        <!-- Escritorio: columna fija. Compacto (< 1400px): hoja inferior -->
        <div class="panel-alerts__commands" [class.is-open]="commandsSheetOpen">
          <div
            class="panel-alerts__sheet-header"
            appSheetSwipe
            sheetSelector=".panel-alerts__commands"
            (swipeDown)="closeCommandsSheet()"
          >
            <span class="panel-alerts__sheet-handle"></span>
            <span
              class="panel-alerts__sheet-close"
              role="button"
              tabindex="0"
              [attr.aria-label]="'general.close' | translate"
              (click)="closeCommandsSheet()"
              (keydown.enter)="closeCommandsSheet()"
              >&times;</span
            >
          </div>
          <app-panel-commands
            [items]="commandItems"
            [feeders]="feeders"
            (run)="runCommand($event)"
            (emptySubmitted)="submitEmpty($event)"
          ></app-panel-commands>
        </div>

        <div class="panel-alerts__right">
          <!-- Compacto: boton que abre la hoja de comandos con su resumen de estado -->
          <button
            type="button"
            class="panel-alerts__commands-trigger"
            (click)="openCommandsSheet()"
          >
            <em class="fa fa-paper-plane" aria-hidden="true"></em>
            <span class="panel-alerts__trigger-label">{{ "panel-alerts.send-command" | translate }}</span>
            <span class="panel-alerts__trigger-badge is-waiting" *ngIf="commandsSummary.waiting > 0">
              <em class="fa fa-clock" aria-hidden="true"></em>{{ commandsSummary.waiting }}
            </span>
            <span class="panel-alerts__trigger-badge is-finished" *ngIf="commandsSummary.finished > 0">
              <em class="fa fa-check" aria-hidden="true"></em>{{ commandsSummary.finished }}
            </span>
            <em class="fa fa-chevron-up panel-alerts__trigger-chevron" aria-hidden="true"></em>
          </button>
          <div class="panel-alerts__list">
            <app-panel-feeders
              [feeders]="visibleFeeders"
              [filters]="filters"
              [sentCommands]="sentCommandKeys"
              [lastResponse]="lastResponseLabel"
              [timezone]="timezone"
              (filtersChange)="changeFilters($event)"
              (toggleCheck)="toggleCheck($event)"
              (retry)="retryCommand($event)"
            ></app-panel-feeders>
          </div>
          <app-panel-footer
            [gateways]="gateways"
            [activeGatewayId]="activeGatewayId"
            [progress]="progress"
            [counters]="counters"
            [queue]="queueSummary"
          ></app-panel-footer>
        </div>
      </div>
    </div>
  </div>
</ng-template>
